import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Menu from "./components/Menu";
import Game from "./components/Game";
import GameOver from "./components/GameOver";
import Victory from "./components/Victory";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Switch>
          <Route exact path="/" component={Menu} />
          <Route exact path="/game" component={Game} />
          <Route exact path="/gameover" component={GameOver} />
          <Route exact path="/victory" component={Victory} />
        </Switch>
      </div>
    );
  }
}

export default App;
